<template>
  <div
    v-loading="isLoading"
    class="layout-warp"
    :element-loading-text="customLoadingText"
    :element-loading-spinner="customLoadingIcon"
    :element-loading-background="customLoadingBg"
    @click="contextMenuVisible = false"
  >
    <el-container class="layout-warp-container">
      <el-aside class="aside-box s-f-c" :width="collapse ? '60px' : '240px'">
        <div class="logo-bar" :style="{ backgroundColor: color[theme.logo], padding: '10px' }">
          <el-image
            :style="{ height: '30px', width: collapse ? '40px' : '220px' }"
            :src="collapse ? require('@/assets/images/logo/icon.png') : require('@/assets/images/logo/logo2.png')"
            fit="contain"
          />
        </div>
        <div class="menu-box">
          <el-scrollbar style="height: 100%" :style="{backgroundColor: color[theme.menu]}">
            <el-menu
              ref="elMenu"
              :collapse="collapse"
              unique-opened
              :default-active="tagView[tagIndex] && tagView[tagIndex].meta.guid ? tagView[tagIndex].meta.guid : ''"
              :collapse-transition="true"
              :text-color="theme.menu === 0 ? '#4d5259' : '#ffffff'"
              :active-text-color="theme.menu === 0 ? '#4d5259' : theme.menu === 1 ? '#b13436' : '#ffffff'"
              mode="vertical"
              :background-color="color[theme.menu]"
              @select="handleMenuClick"
            >
              <subMenu-item
                v-for="(item, index) in sidebarRouters"
                :key="index"
                :data="item"
              />
              <!-- :text-color="theme.menu === 0 ? '#4d5259' : theme.menu === 1 ? '#b13436' : '#ffffff'" -->
            </el-menu>
          </el-scrollbar>
        </div>
        <div
          class="logut-bar"
          :style="{ backgroundColor: color[theme.menu], color: theme.menu === 0 ? '#4d5259' : '#ffffff' }"
        >
          <p class="logout-btn" @click="handleNavCommand('logout')">
            <i class="iconfont icon-turn-off" />
            <span> Logout</span>
          </p>
        </div>
      </el-aside>
      <el-container>
        <el-header class="top-header" height="50px">
          <div class="nav-bar" :class="{'is-vip': userInfo.isVip}" :style="{ backgroundColor: color[theme.head] }">
            <tool-bar :collapse="collapse" :breadcrumb="breadcrumbList" @command="handleNavCommand" />
          </div>
          <!-- <div class="tags-bar">
            <el-scrollbar ref="scrollContainer" style="width: 100%" :vertical="false">
              <div class="tag-scroll">
                <el-tag v-for="(tv, index) in tagView" :key="index" :closable="!tv.affix" size="small" ref="tag" hit
                  disable-transitions class="tag-item" :class="tagIndex === index ? 'is-active' : ''"
                  @click="jumpTargetTag(index)" @close="handleCloseTag(index)"
                  @contextmenu.prevent.native="openContextMenu(index, $event)">
                  <font class="" v-if="tagIndex === index">●</font>
                  {{ tv.meta.title || '菜单' }}
                </el-tag>
              </div>
            </el-scrollbar>
            <ul v-show="contextMenuVisible" :style="{
              left: contextMenuLeft + 'px',
              top: contextMenuTop + 'px'
            }" class="contextmenu">
              <li @click="refreshTab">刷新当前</li>
              <li v-if="tagIndex < tagView.length && !tagView[tagIndex].affix" @click="handleCloseTag">关闭当前</li>
              <li @click="handleCloseOther">关闭其它标签</li>
              <li @click="handleCloseAll">关闭所有标签</li>
            </ul>
          </div> -->
        </el-header>
        <el-main class="app-main">
          <el-scrollbar ref="scroll" style="height: 100%" wrap-class="scrollbar-wrapper">
            <transition name="fade-transform" mode="out-in">
              <keep-alive :exclude="excludeName" :include="tagView">
                <router-view v-if="!refreshFlag" :key="key" />
              </keep-alive>
            </transition>
          </el-scrollbar>
        </el-main>
      </el-container>
    </el-container>
    <el-drawer title="Customize" :visible.sync="layoutSet" direction="rtl" :modal="false">
      <layout-set />
    </el-drawer>

    <div v-if="backTop" class="top_back" @click="handleTop">
      <i class="el-icon-caret-top" />
    </div>
    <!-- <div  v-if="backTop" class="bot_back" @click="handleBot">
      <i class="el-icon-caret-bottom"></i>
    </div> -->
   <!-- <div v-if="contantShow" class="contant">
      <div class="contantx" @click="bounceClick">Hide<i class="el-icon-caret-right" /></div>

      <div v-for="(j, k) in contantData" :key="k" class="contantbox">
        <img :src="j.img" alt="">
        <div class="skypeBox" :style="'border:3px solid' + j.color + ';color:' + j.color">
          <div v-for="(v, i) in j.childData" :key="i" class="skypeOne" @click="contantClick(v)">
            <div class="svgbox">
              <svg class="icon" aria-hidden="true">
                <use :xlink:href="v.icon" />
              </svg>
            </div>
            <p class="svgp">{{ v.name }}</p>
          </div>
        </div>
      </div> -->

      <!-- <div v-if="showTicket" class="contantbox">
        <el-tooltip content="create ticket" placement="left" effect="light">
          <img src="@/assets/content/ticket.png" class="cursor-pointer" alt="create ticket" @click="createTicket">
        </el-tooltip>
      </div> -->
    <!-- </div> -->
    <div v-if="!contantShow" class="contants" @click="bounceClick">
      <!-- {{contantShow?'弹出':'收缩'}} -->
    </div>

    <TicketsForm ref="ticketForm" />
  </div>
</template>

<script>
import storage from '@/utils/storage'
import toolBar from './components/tool-bar.vue'
import subMenuItem from './components/subMenu-item.vue'
import layoutSet from './components/layout-set.vue'
import { mapState, mapGetters } from 'vuex'
import TicketsForm from '@/views/tickets/components/ticketsForm.vue'
// const tagAndTagSpacing = 6
export default {
  name: 'Layout',
  components: { toolBar, subMenuItem, layoutSet, TicketsForm },
  data() {
    return {
		num: 0,
      collapse: false,
      // 要缓存的路由名称
      excludeName: '',
      // 刷新标志
      refreshFlag: false,
      tagIndex: undefined,
      contextMenuVisible: false,
      contextMenuLeft: 0,
      contextMenuTop: 0,
      // 是否显示布局设置
      layoutSet: false,
      color: ['#ffffff', '#2b2f3a', '#15c377', '#48b0f7', '#faa64b', '#f96868', '#926dde', '#33cabb'],
      timerId: null,
      openTimerId: null,
      breadcrumbList: [],

      /* 右侧浮动按钮数据 */
      backTop: false,
      contantShow: true,
      contantData: [
        {
          img: require('@/assets/content/skype.png'),
          color: '#00A9E5',
          childData: [
            {
              // 老板
              name: 'Brian',
              path: 'skype:live:ccbbc120bebbcd97?chat',
              icon: '#icon-skype'
              // color: '#00A9E5'
            },
            {
              // 海涛
              name: 'Tao',
              path: 'skype:live:.cid.3332e12c2d092deb?chat',
              icon: '#icon-skype'
              // color: '#00A9E5'
            }
          ]
        },
        {
          img: require('@/assets/content/whatsapp.png'),
          color: '#4ECC5C',
          childData: [
            {
              // 老板
              name: 'Brian',
              path: 'https://api.whatsapp.com/send?phone=008615924173139',
              icon: '#icon-whatsapp'
              // color: '#4ECC5C'
            },
            {
              // 海涛
              name: 'Tao',
              path: 'https://api.whatsapp.com/send?phone=008613237989260',
              icon: '#icon-whatsapp'
              // color: '#4ECC5C'
            }
          ]
        }
      ]
    }
  },
  computed: {
    scrollWrapper() {
      return this.$refs.scrollContainer.$refs.wrap
    },
    ...mapState({
      hasLogin: (state) => state.user.hasLogin,
      userInfo: (state) => state.user.userInfo,
      // theme: (state) => state.settings.theme,
      sidebarRouters: (state) => state.routes.sidebarRouters,
      tagView: (state) => state.routes.tagView
    }),

    ...mapGetters(['theme']),

    key() {
      return this.$route.path
    },

    showTicket() {
      if (this.$route.fullPath.indexOf('/function/tickets') === 0) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    $route() {
		this.num += 1
      this.breadcrumbList = this.getTreePathByKey(this.$route.meta.guid, this.sidebarRouters, 'guid')
	  if (this.num > 2) return
      if (this.timerId) clearTimeout(this.timerId)
      setTimeout(() => {
        var tag = {
          guid: this.$route.meta.guid,
          path: this.$route.path,
          meta: this.$route.meta,
          name: this.$route.name
        }
        this.$store.dispatch('AddTagView', tag).then((index) => {
          this.tagIndex = index
          this.$nextTick(() => {
            this.slideTag(this.tagIndex)
          })
        })
      }, 50)
    }
  },
  created() {
    var value = storage.getLocal('theme')
    if (value && value.length > 0) {
      this.$store.commit('SET_THEME', JSON.parse(value))
    }
    this.initTagView()
  },

  mounted() {
    const handleScroll = this.$refs.scroll.handleScroll
    const data = this.$refs.scroll.$data
    const self = this
    this.$refs.scroll.handleScroll = function(e) {
      handleScroll()
      // console.log(data)
      if (data.moveY > 50) {
        self.backTop = true
      } else {
        self.backTop = false
      }
    }
  },

  methods: {
    // 菜单点击事件
    handleMenuClick(index) {
      var data = JSON.parse(JSON.stringify(this.sidebarRouters))
      var route = this.filterRoute(index, data)
      if (route) this.openRoute(route)
    },
    // 工具条事件
    handleNavCommand(command) {
      switch (command) {
        default:
          break
        case 'refresh-tab':
          this.refreshTab()
          break
        case 'collapse':
          this.collapse = !this.collapse
          break
        case 'layout-set':
          this.layoutSet = !this.layoutSet
          break
        case 'profile':
          this.handleMenuClick('profile')
          break
        case 'setting':
          this.$router.replace('/setting')
          break
        case 'logout':
          this.$confirm('Are you sure to log out of the system ?', 'Message', {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            type: 'warning'
          })
            .then(() => {
              const customer = localStorage.getItem('customer')
              this.$store.dispatch('LogOut')
              let url = '/login'
              if (customer) {
                url += '?customer=' + customer
              }
              this.$router.replace(url)
              // this.$notify({
              //   title: '成功退出',
              //   message: '欢迎下次继续使用！',
              //   type: 'success'
              // })
            })
            .catch(() => {})
          break
      }
    },
    // 右键菜单
    openContextMenu(index, e) {
      this.jumpTargetTag(index)
      this.contextMenuLeft = this.collapse ? e.pageX - 60 : e.pageX - 240
      this.contextMenuTop = e.pageY - 50
      this.contextMenuVisible = true
    },
    // 刷新当前标签
    refreshTab() {
      var route = JSON.parse(JSON.stringify(this.tagView[this.tagIndex]))
      if (route.name && route.name.length > 0 && route.path && route.path.length > 0) {
        this.refreshFlag = true
        this.excludeName = route.name
        this.openRoute(route)
        this.$nextTick(() => {
          this.refreshFlag = false
          this.excludeName = ''
        })
      }
    },
    // 激活当前标签
    jumpTargetTag(index) {
      if (this.tagIndex === index || index >= this.tagView.length) return
      this.tagIndex = parseInt(index)
      var route = this.tagView[this.tagIndex]
      this.openRoute(route)
    },
    // 关闭所有标签
    handleCloseAll() {
      var names = ''
      if (this.tagView && this.tagView.length > 1) {
        for (let i = 0; i < this.tagView.length; i++) {
          names += (names.length > 0 ? ',' : '') + this.tagView[i].name
        }
      }
      this.excludeName = names
      var length = this.tagView.length - 1
      for (let index = length; index >= 0; index--) {
        this.$store.dispatch('DeleteTagView', index).then((e) => {
          if (index === 0 && e >= 0 && e < this.tagView.length) {
            this.tagIndex = e
            var route = this.tagView[e]
            this.openRoute(route)
            this.$nextTick(() => {
              this.refreshFlag = false
              this.excludeName = ''
            })
          }
        })
      }
    },
    // 关闭其他标签
    handleCloseOther() {
      var index = parseInt(this.tagIndex)
      var guid = this.tagView[index].meta.guid
      var names = ''
      if (this.tagView && this.tagView.length > 1) {
        for (let i = 0; i < this.tagView.length; i++) {
          if (i !== index) names += (names.length > 0 ? ',' : '') + this.tagView[i].name
        }
      }
      this.excludeName = names
      var length = this.tagView.length - 1
      for (let i = length; i >= 0; i--) {
        if (i !== index) {
          this.$store.dispatch('DeleteTagView', i).then(() => {
            if (i === 0) {
              index = this.tagView.findIndex((el) => {
                return el.meta.guid === guid
              })
              if (index >= 0 && index < this.tagView.length) {
                this.tagIndex = parseInt(index)
                var route = this.tagView[index]
                this.openRoute(route)
                this.$nextTick(() => {
                  this.refreshFlag = false
                  this.excludeName = ''
                })
              }
            }
          })
        }
      }
    },
    // 关闭当前标签
    handleCloseTag(i) {
      var index = (i || i === 0) && !isNaN(i) && Number(i) >= 0 ? i : this.tagIndex
      this.excludeName = this.tagView[index].name
      this.$store.dispatch('DeleteTagView', index).then((e) => {
        if (
          e >= 0 &&
          e < this.tagView.length &&
          (!((i || i === 0) && !isNaN(i) && Number(i) >= 0) || i === this.tagIndex)
        ) {
          this.tagIndex = e
          var route = this.tagView[e]
          this.openRoute(route)
          this.$nextTick(() => {
            this.refreshFlag = false
            this.excludeName = ''
          })
        }
      })
    },
    // 滑动tag到合适位置
    slideTag(index) {
      return index
      // const $container = this.$refs.scrollContainer.$el
      // const $containerWidth = $container.offsetWidth
      // const $scrollWrapper = this.scrollWrapper
      // const tagList = this.$refs.tag
      // if (tagList.length > 0) {
      //   if (index === 0) {
      //     $scrollWrapper.scrollLeft = 0
      //   } else if (index === tagList.length - 1) {
      //     $scrollWrapper.scrollLeft = $scrollWrapper.scrollWidth - $containerWidth
      //   } else {
      //     const currentIndex = index
      //     const prevTag = tagList[currentIndex - 1]
      //     const nextTag = tagList[currentIndex + 1]
      //     const afterNextTagOffsetLeft = nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + tagAndTagSpacing
      //     const beforePrevTagOffsetLeft = prevTag.$el.offsetLeft - tagAndTagSpacing
      //     if (afterNextTagOffsetLeft > $scrollWrapper.scrollLeft + $containerWidth) {
      //       $scrollWrapper.scrollLeft = afterNextTagOffsetLeft - $containerWidth
      //     } else if (beforePrevTagOffsetLeft < $scrollWrapper.scrollLeft) {
      //       $scrollWrapper.scrollLeft = beforePrevTagOffsetLeft
      //     }
      //   }
      // }
    },
    // 打开路由
    openRoute(route) {
      if (this.openTimerId) clearTimeout(this.openTimerId)
      this.openTimerId = setTimeout(() => {
        if (route.meta.guid && route.path) {
          var currentPath = this.$router.history.current.path
          if (currentPath === route.path) return
          this.$router.replace(route.path)
        }
      }, 100)
    },
    // 初始化tagView
    initTagView() {
      var data = JSON.parse(JSON.stringify(this.sidebarRouters))
      var list = this.filterAffix(data)
      if (list && list.length) {
        for (let i = 0; i < list.length; i++) {
          var el = list[i]
          this.$store.dispatch('AddTagView', el)
        }
      }
      if (this.timerId) clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        var tag = {
          guid: this.$route.meta.guid,
          path: this.$route.path,
          meta: this.$route.meta,
          name: this.$route.name
        }
        this.$store.dispatch('AddTagView', tag).then((index) => {
          this.tagIndex = index
          // this.$router.replace(this.$route.path)
          this.$nextTick(() => {
            this.slideTag(this.tagIndex)
            this.breadcrumbList = this.getTreePathByKey(this.$route.meta.guid, this.sidebarRouters, 'guid')
          })
        })
      }, 50)
    },
    // 查找固定页面
    filterAffix(data) {
      if (!data || data.length < 1) return undefined
      var list = []
      var filterFun = (data) => {
        for (let i = 0; i < data.length; i++) {
          var el = data[i]
          if (el.children && el.children.length > 0) filterFun(el.children)
          else {
            if (el && el.meta && el.meta.affix) {
              list.push({
                affix: true,
                guid: el.meta.guid,
                name: el.name,
                path: el.path,
                meta: el.meta
              })
            }
          }
        }
      }
      filterFun(data)
      return list
    },
    // 查找路由
    filterRoute(currkey, data) {
      if (!data || data.length < 1) return undefined
      for (let i = 0; i < data.length; i++) {
        const el = JSON.parse(JSON.stringify(data[i]))
        if (el && el.meta && el.meta.guid === currkey) {
          return JSON.parse(JSON.stringify(el))
        } else if (el.children && el.children.length > 0) {
          var res = this.filterRoute(currkey, el.children)
          if (res) return res
        }
      }
      return undefined
    },

    bounceClick() {
      this.contantShow = !this.contantShow
    },

    contantClick(val) {
      window.open(val.path)
    },
    handleTop() {
      // console.dir(this.$refs.scroll.wrap)
      this.$refs.scroll.wrap.scrollTop = 0
    },

    createTicket() {
      this.$refs.ticketForm.open({}, async(data) => {
        // console.log(this.$route, 'route')
        this.$router.push('/function/tickets')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-warp {
  height: 100vh;
  overflow: hidden;

  &-container {
    height: 100%;

    .aside-box,
    .app-main {
      padding: 0;
      margin: 0;
      overflow: hidden;
      box-shadow: 0 0 1px rgba($color: #000000, $alpha: 0.25);
      background-color: #f6f6f6;
    }

    .aside-box {
      transition: width 0.5s;

      .logo-bar {
        width: 100%;
        height: 50px;
        overflow: hidden;
      }

      .menu-box {
        flex: 1;
        overflow: hidden;

        :deep() {
          .el-scrollbar__wrap {
            overflow-x: hidden;
          }

          .el-scrollbar__view {
            height: 100%;
          }

          .el-menu {
            height: 100%;
            border-right: none;

            .el-menu-item,
            .el-submenu__title {
              background-color: transparent !important;
            }

            .el-menu-item.is-active {
              // border-left: 4px solid;
              // font-weight: bold;
              box-sizing: border-box;
              background-color: rgba($color: #000, $alpha: 0.1) !important;
            }

            .el-submenu__title:focus,
            .el-submenu__title:hover,
            .el-menu-item:focus,
            .el-menu-item:hover {
              background-color: rgba($color: #000, $alpha: 0.1);
            }
          }
        }
      }

      .logut-bar {
        padding: 2px 2px 0;

        .logout-btn {
          text-align: center;
          line-height: 40px;
          border-radius: 4px;
          height: 40px;
          cursor: pointer;

          &:hover {
            background: linear-gradient(90deg, rgba(216, 14, 14, 1) 0%, rgba(242, 130, 130, 1) 100%) !important;
          }
        }
      }
    }

    .top-header {
      padding: 0;
      margin: 0;
      box-shadow: 0 0 1px rgba($color: #000000, $alpha: 0.25);

      .nav-bar {
        height: 50px;
        border-bottom: 1px solid #f3f3f3;
          background: url('@/assets/img/decorate-r-l.png') no-repeat 2px 2px, url('@/assets/img/decorate-r-r.png') no-repeat 99.8% -2px;
          background-size: 85px 50px;
        &.is-vip {
          background: url('@/assets/img/decorate.png') no-repeat 2px 2px, url('@/assets/img/decorate2.png') no-repeat 99.8% -2px;
          background-size: 85px 50px;
        }
      }

      .tags-bar {
        height: 30px;
        padding: 3px 5px;
        position: relative;

        .tag-scroll {
          white-space: nowrap;

          :deep() {
            .el-tag__close {
              color: #505050;

              &:hover {
                background-color: #d8dce5;
              }
            }

            .is-active .el-tag__close {
              color: #fff;

              &:hover {
                background-color: #f0f0f0;
              }
            }
          }

          .tag-item {
            margin: 0 3px;
            cursor: pointer;
            -moz-user-select: none;
            -webkit-user-select: none;
            -ms-user-select: none;
            -khtml-user-select: none;
            -o-user-select: none;
            user-select: none;
            border-radius: 0;
            background-color: #fff;
            color: #505050;
            border-color: #d8dce5;

            &.is-active {
              background-color: #409eff;
              color: #fff;
              border-color: #409eff;
            }
          }
        }

        .contextmenu {
          margin: 0;
          background: #fff;
          z-index: 3000;
          position: absolute;
          list-style-type: none;
          padding: 5px 0;
          border-radius: 4px;
          font-size: 12px;
          font-weight: 400;
          color: #333;
          box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

          li {
            margin: 0;
            padding: 7px 16px;
            cursor: pointer;

            &:hover {
              background: #eee;
            }
          }
        }
      }
    }
  }

  .app-main {
    .page-box {
      height: 100%;
    }
  }
}

/* === */
.top_back {
  position: fixed;
  background-color: #fff;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  color: #d81010;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  z-index: 500;
  right: 30px;
  // bottom: 20px;
  top: 50%;
  margin-top: 200px;

  &:active {
    background: #f2f6fc;
  }

  &:hover {
    background: #f2f6fc;
  }
}
.bot_back {
  position: fixed;
  background-color: #fff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #d81010;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  z-index: 5;
  right: 80px;
  bottom: 20px;

  &:active {
    background: #f2f6fc;
  }

  &:hover {
    background: #f2f6fc;
  }
}
.contant {
  z-index: 500;
  border: 3px solid #f06060;
  position: fixed;
  right: 25px;
  top: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  box-sizing: border-box;
  border-radius: 5px;
  background: #fff;

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -.15em;
  fill: currentColor;
  overflow: hidden;
}

  .contantx {
    position: relative;
    cursor: pointer;
    // font-size: 2px;
    font-weight: 700;
    color: #f06060;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      font-size: 20px;
    }
  }
  .contantx:hover {
    color: #d81010;
  }
  .contantbox {
    width: 50px;
    height: 50px;
    margin: 5px 0;
    // cursor: pointer;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }
    .skypeBox {
      border: 3px solid #f06060;
      border-radius: 5px;
      position: absolute;
      width: 140px;
      height: 50px;
      top: 0;
      left: -140px;
      background: #fff;
      display: none;
      .skypeOne {
        flex: 1;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .svgbox {
          display: flex;
          align-items: center;
          justify-content: center;
          svg {
            font-size: 20px;
          }
        }
        .svgp {
          text-align: center;
          font-weight: 500;
        }
      }
    }
  }
  .contantbox:hover {
    .skypeBox {
      display: flex;
    }
  }
}
.contants {
  // display: none;
  z-index: 5000;
  //     border: 3px solid #f06060;
  //     position: fixed;
  //     right: 25px;
  //     top: 50%;
  //     padding: 5px;
  position: fixed;
  width: 0;
  height: 0;
  border: 20px solid transparent;
  border-bottom-color: #f06060;
  top: 60%;
  right: 0;
  cursor: pointer;
  transform: rotate(270deg);
}
.contants:hover {
  border-bottom-color: #d81010;
}
</style>
